import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "react-highcharts";
import { orderBy } from "lodash";
import PropTypes from 'prop-types';

export function handleData(res) {
  let graphData = [];
  res && res.forEach(data => {
    graphData.push({
      x: data.date,
      y: data.value
    });
  });
  let descData = orderBy(graphData, ["x"], ["asc"]);
  return descData;
}

export default function Chart(props) {
  const chartConfig = {
    chart: {
      height: props.height,
      width: props.width,
      type: "line",
      backgroundColor: null
    },
    title: {
      text: ""
    },
    subtitle: {
      text: ""
    },
    credits: { enabled: false },
    yAxis: {
      visible: false
    },
    xAxis: {
      visible: false
    },
    plotOptions: {
      series: { enableMouseTracking: false }
    },
    series: [
      {
        data: handleData(props.chartData),
        lineWidth: 4,
        color: props.strokeColor,
        marker: {
          enabled: false
        }
      }
    ],
    tooltip: { enabled: false },
    legend: {
      enabled: false,
      align: "right",
      verticalAlign: "middle"
    }
  };
  return (
    <>
      <HighchartsReact data-test = "container" highcharts={Highcharts} config={chartConfig} />
    </>
  );
}
Chart.propTypes = {
  handleData: PropTypes.func,
  graphData: PropTypes.array,
  descData: PropTypes.arrayOf(PropTypes.object),
  chartData: PropTypes.arrayOf(PropTypes.object)
}